const baseProps = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

function SvgIcon({ children, className }) {
  return (
    <svg {...baseProps} className={className} aria-hidden="true">
      {children}
    </svg>
  );
}

export function TailDashboardIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 3.25A2.25 2.25 0 0 0 3.25 5.5V9A2.25 2.25 0 0 0 5.5 11.25H9A2.25 2.25 0 0 0 11.25 9V5.5A2.25 2.25 0 0 0 9 3.25H5.5ZM4.75 5.5a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-.75.75H5.5A.75.75 0 0 1 4.75 9V5.5ZM5.5 12.75A2.25 2.25 0 0 0 3.25 15v3.5a2.25 2.25 0 0 0 2.25 2.25H9a2.25 2.25 0 0 0 2.25-2.25V15A2.25 2.25 0 0 0 9 12.75H5.5ZM4.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75V15ZM12.75 5.5A2.25 2.25 0 0 1 15 3.25h3.5a2.25 2.25 0 0 1 2.25 2.25V9a2.25 2.25 0 0 1-2.25 2.25H15A2.25 2.25 0 0 1 12.75 9V5.5ZM15 4.75a.75.75 0 0 0-.75.75V9c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75V5.5a.75.75 0 0 0-.75-.75H15ZM15 12.75A2.25 2.25 0 0 0 12.75 15v3.5A2.25 2.25 0 0 0 15 20.75h3.5a2.25 2.25 0 0 0 2.25-2.25V15a2.25 2.25 0 0 0-2.25-2.25H15ZM14.25 15a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function TailCampaignIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M4.75 13.1V9.75a2 2 0 0 1 2-2h2.32l7.3-3.05a1.25 1.25 0 0 1 1.73 1.15v11.5a1.25 1.25 0 0 1-1.73 1.15l-7.3-3.05H6.75a2 2 0 0 1-2-2.35Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8.75 15.25 10 20h2.1a1 1 0 0 0 .96-1.28l-1.06-3.47" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.25 9.25v5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function TailPackageIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="m12 3.75 7.25 3.8v8.9L12 20.25l-7.25-3.8v-8.9L12 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="m4.95 7.7 7.05 3.7 7.05-3.7M12 11.4v8.55" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function TailUsersIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M15.25 19.25v-1.1c0-2.1-1.72-3.8-3.84-3.8H7.6a3.82 3.82 0 0 0-3.85 3.8v1.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9.5 10.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM20.25 19.25v-.95a3.3 3.3 0 0 0-2.85-3.26M15.9 4.96a3 3 0 0 1 0 5.58" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function TailClipboardIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M9 5.75h6M9 10.75h6M9 15.75h3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.75 3.75h6.5a2 2 0 0 1 2 2v12.5a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2V5.75a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.5" />
    </SvgIcon>
  );
}

export function TailMessageIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M4.75 6.75a3 3 0 0 1 3-3h8.5a3 3 0 0 1 3 3v5.5a3 3 0 0 1-3 3H11l-4.2 4a.75.75 0 0 1-1.26-.54v-3.62a3 3 0 0 1-.79-2.04v-6.3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8.5 8.75h7M8.5 11.75h4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function TailFileIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M7.75 3.75h6.4l4.1 4.1v10.4a2 2 0 0 1-2 2h-8.5a2 2 0 0 1-2-2V5.75a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M14.25 4v4.25h4.25M9 12.25h6M9 15.25h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function TailCodeIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="m9.25 8.25-4 3.75 4 3.75M14.75 8.25l4 3.75-4 3.75M13 5.75l-2 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function TailSettingsIcon({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M12 14.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M19.25 12.6v-1.2l-2.05-.58a5.7 5.7 0 0 0-.55-1.33l1.04-1.86-.85-.85-1.86 1.04a5.7 5.7 0 0 0-1.33-.55L13.07 5.2h-1.2l-.58 2.07a5.7 5.7 0 0 0-1.33.55L8.1 6.78l-.85.85 1.04 1.86a5.7 5.7 0 0 0-.55 1.33l-2.05.58v1.2l2.05.58c.13.47.32.92.55 1.33l-1.04 1.86.85.85 1.86-1.04c.41.23.86.42 1.33.55l.58 2.07h1.2l.58-2.07a5.7 5.7 0 0 0 1.33-.55l1.86 1.04.85-.85-1.04-1.86c.23-.41.42-.86.55-1.33l2.05-.58Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

